export enum CountrySettings {
    AT = 'AT',
    DE = 'DE',
    EN = 'EN',
    ES = 'ES',
    IT = 'IT',
    FR = 'FR',
}